var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49603 8.72879C5.49603 9.19378 5.87418 9.56913 6.33916 9.56913C6.56045 9.56913 6.77614 9.47949 6.933 9.31983L11.2103 5.03692V16.0873C11.2271 16.5299 11.5829 16.8828 12.0226 16.8996C12.4904 16.9165 12.8826 16.5523 12.8994 16.0873V5.03692L17.1095 9.2498C17.1124 9.25271 17.1149 9.25563 17.1174 9.25842C17.1221 9.26369 17.1264 9.26855 17.1319 9.27221C17.468 9.59434 18.0002 9.58593 18.3251 9.2498C18.6473 8.91367 18.6389 8.38145 18.3027 8.05652L12.6529 2.40107C12.3223 2.07334 11.7901 2.07334 11.4596 2.40107L5.74253 8.12935C5.58566 8.28902 5.49603 8.5047 5.49603 8.72879ZM21.8405 16.9109C21.8405 16.4459 21.4624 16.0677 20.9974 16.0677C20.5324 16.0677 20.1543 16.4459 20.1571 16.9109V20.1545H3.84337V16.9109C3.82656 16.4683 3.47082 16.1153 3.03105 16.0985C2.56326 16.0817 2.1711 16.4459 2.1543 16.9109V20.9977C2.1543 21.4627 2.53245 21.8408 2.99743 21.8408H20.9974C21.4624 21.8408 21.8405 21.4627 21.8405 20.9977V16.9109Z",
    fill: "#660099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportRegular);
export default __webpack_public_path__ + "static/media/export-regular.191975ac8a74a2a4efd04e376e69322b.svg";
export { ForwardRef as ReactComponent };